export const adcellPid = 10265
